import type {AsyncVoidFunction} from '@Utils/general.util';
import type {AiPromptBoxContextualMenu} from '@Components/ai-prompt-box/components/ai-prompt-box-footer-actions/ai-prompt-box-contextual-menu/ai-prompt-box-contextual-menu.types';
import type {AiPromptBoxAttachments} from '@Components/ai-prompt-box/components/ai-prompt-box-attachments/ai-prompt-box-attachments.types';
import type {AiPromptBoxIssue} from '@Components/ai-prompt-box/components/ai-prompt-box-issue/ai-prompt-box-issue.types';
import type {FooterLeftAction} from '@Components/ai-prompt-box/components/ai-prompt-box-footer/ai-prompt-box-footer.types';
import type {PromptSuggestionPills} from "@Components/ai-prompt-box/components/ai-prompt-box-prompt-suggestions/ai-prompt-box-prompt-suggestions.types";
import type {CreditsPillContent} from "@Components/ai-prompt-box/components/ai-prompt-box-credits-pill/ai-prompt-box-credits-pill.types";


export type SelectedContextualMenuItems = Record<string, string[]>;

export interface AiPromptBoxProps {
  id: string;
  initialConfig: AiPromptBox;
  onGenerate: AsyncVoidFunction;
  onRegenerate: AsyncVoidFunction;
  onStop: AsyncVoidFunction;
  options?: FooterLeftAction[];
  containerClasses?: string;
  size?: AiPromptBoxSize
}

export enum AiPromptBoxSize  {
  SMALL = 'small',
  MEDIUM = 'medium',
}

export type AiPromptBoxReduxState = Record<string, AiPromptBox | undefined>;

export interface AiPromptBoxInitializationAction {
  id: string;
  value: AiPromptBox;
}

export interface AiPromptBoxUpdateAction {
  id: string;
  value: Partial<AiPromptBox>;
}

export interface AiPromptBox {
  prompt: string;
  placeholder: string;
  showInitialAnimation?: boolean;
  contextualMenu?: AiPromptBoxContextualMenu;
  creditsPill?: CreditsPillContent;
  promptBoxState: PromptBoxState;
  promptSuggestions?: PromptSuggestionPills;
  attachments?: AiPromptBoxAttachments;
  size: AiPromptBoxSize;
  error?: AiPromptBoxIssue;
}

export enum PromptBoxState {
  IDLE = 'idle',
  ACTIVE = 'active',
  DISABLED = 'disabled',
  LOADING = 'loading',
  STOPPABLE_LOADING = 'stoppable-loading',
  REGENERATE = 'regenerate',
}
